import { paymentMethodConstants } from "../_constants";

export default function paymentMethod(state = {}, action) {
  switch (action.type) {
    //get
    case paymentMethodConstants.GET_PAYMENT_METHOD_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentMethodConstants.GET_PAYMENT_METHOD_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getPaymentMethodList: action?.user?.data,
      };
    case paymentMethodConstants.GET_PAYMENT_METHOD_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //add
    case paymentMethodConstants.CREATE_PAYMENT_METHOD_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentMethodConstants.CREATE_PAYMENT_METHOD_LIST_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case paymentMethodConstants.CREATE_PAYMENT_METHOD_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //  update
    case paymentMethodConstants.UPDATE_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentMethodConstants.UPDATE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,

        loading: false,
        error: action?.user,
      };
    case paymentMethodConstants.UPDATE_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //delete
    case paymentMethodConstants.DELETE_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentMethodConstants.DELETE_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case paymentMethodConstants.DELETE_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //update status
    case paymentMethodConstants.UPDATE_PAYMENT_METHOD_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentMethodConstants.UPDATE_PAYMENT_METHOD_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action?.user,
      };
    case paymentMethodConstants.UPDATE_PAYMENT_METHOD_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //get country code list
    case paymentMethodConstants.GET_COUNTRY_CODE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentMethodConstants.GET_COUNTRY_CODE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getCountry: action?.user?.data,
      };
    case paymentMethodConstants.GET_COUNTRY_CODE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    case paymentMethodConstants.GET_PKRD_PAYMENT_HISTORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case paymentMethodConstants.GET_PKRD_PAYMENT_HISTORY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        getPkrdPaymentList: action?.user?.data,
      };
    case paymentMethodConstants.GET_PKRD_PAYMENT_HISTORY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };











    default:
      return state;
  }
}
